import { render, staticRenderFns } from "./superCollectPack2.vue?vue&type=template&id=c621f05e&scoped=true&"
import script from "./superCollectPack2.vue?vue&type=script&lang=js&"
export * from "./superCollectPack2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c621f05e",
  null
  
)

export default component.exports